import React from 'react';
import Banner from '../../banner';

var ThemeUnsupported = function ThemeUnsupported() {
  return /*#__PURE__*/React.createElement(Banner, {
    message: "This component is not supported in the current theme.",
    brand: "danger",
    shouldDisplay: true
  });
};

export default ThemeUnsupported;